import { InjectionToken } from "@angular/core";
import * as Model from '../../models/public_api';
import { Observable } from "rxjs";
import { IDocusignTemplate, IDeleteDocusignTemplate, IUserCard, ITemplateEditStepViewModel, ISignatureRole, IFrontFaceQuestion, ICountryQuestionModel } from "../../models/public_api";

export const IFUNDSETUP_SERVICE = new InjectionToken<IFundSetupService>(
  "fundSetupService"
);

export interface IFundSetupService {
  loadDataForSurveyManagerPage(): Observable<Model.SurveyTemplateViewModel>;
  getFundOnboardingList(): Observable<Model.FundOnBoardingOutput>;
  getFundArrayForLaunch(): Observable<Model.FundOnBoarding[]>;
  getFundSetupSteps(fundOnboardingId: number, isRevise: boolean): Observable<Model.StepModel[]>;
  getFundOnboardingDetail(fundOnboardingId: number, fundId: number): Observable<Model.FundOnBoardingDetail>;
  getAccountContactArray(fundId: number): Observable<Model.FundAccount[]>;
  updateAccountContactArray(insertOrUpdateAccountArray: Model.FundAccount[], deleteAccountArray: Model.FundAccount[]): Observable<boolean>;
  createFundShell(fundShell: Model.IFundShell): Observable<number>;
  updateFundInfo(fund: Model.FundOnBoardingDetail): Observable<boolean>;
  getInvestorRoleSetupUser(fundId: number): Observable<Model.RoleSetupUser[]>;
  getClientRoleSetupUser(fundId: number): Observable<Model.RoleSetupUser[]>;
  getRoleSetupUserArray(fundId: number): Observable<Model.IRoleSetupViewModel>;
  InsertClient(insertedClient: Model.IRoleSetupUser): Observable<number>;
  updateRoleSetup(roleList: Model.IUserRole[], onboardingFundId: number, spinOrLoading: boolean | 'spin'): Observable<boolean>;
  getTemplateListByOnboardingFundId(onboardingFundId: number): Observable<ITemplateEditStepViewModel>;
  getSubDocSharedModelByOnboardingFundId(onboardingFundId: number): Observable<ICountryQuestionModel>;
  initializeHardCodeCustomField(): Observable<boolean>;
  deleteHardCodeCustomField(): Observable<boolean>;
  getInvestorRoleArray(isShowSpin?: boolean): Observable<{ id: number, roleName: string }[]>;
  updateContactRole(contacts: Model.ContactOfAccount[]): Observable<boolean>;

  getSurveyTemplateList(): Observable<Model.SurveyTemplate[]>;
  getQuestionLib(isShowSpin: boolean): Observable<Model.QuestionTemplate[]>;
  getSurveyTemplateSteps(templateId: number): Observable<Model.SurveyTemplateStep[]>;

  getInvestorTypeList(): Observable<string[]>;
  getDetailOfSurveyTemplate(selectedTemplate: Model.ISurveyTemplate, questionLib: Model.IQuestionTemplate[]): Observable<Model.ISurveyTemplate>;
  getTempalteStepsForSelectedInvestorType(selectedInvestorType: Model.InvestorTypeTemplate): Model.SurveyTemplateStep[];
  getguid();

  getFlexQuestionDisplayTypeArray(): { renderType: string, renderSetting: string, styleClass: string, displayLabel: string }[];
  getAnswerOptionArray(fileName: string): Observable<{ value: string, point: number }[]>;
  updateDisplayOrder(orderArray: { displayOrder: number }[]);
  getSurveyStepNameArray(): string[];
  downloadTemplateFile(templateFileName: string);
  downloadManualAgreement(onboardingAccountId: number);

  insertNewSurveyTemplate(insertedSurveyTemplate: Model.ISurveyTemplate): Observable<boolean>;
  insertOrUpdateQuestionTemplateToBackEndAndFetchId(insertedQuestion: Model.IQuestionTemplate): Observable<Model.IQuestionTemplate>;

  createTemplateInDocSign(insertedAgreementTemplate: Model.IAgreementTemplate): Observable<Model.IAgreementTemplate>;
  getTemplateConsolePanel(docusignTemplate: Model.IDocusignTemplate): Observable<string>;
  createDocusignTemplate(docusignTemplate: Model.IDocusignTemplate): Observable<Model.IDocusignTemplate>;
  deleteDocusignTemplate(docusignTemplateId: number): Observable<IDeleteDocusignTemplate>;
  removeTemplateFile(docTemplateId: number): Observable<boolean>;
  deleteAgreementTemplate(agreementTemplateId: number): Observable<boolean>;

  getCustomFieldArray(): Observable<Model.CustomField[]>;
  insertCustomFiledInDocSign(insertedCustomField: Model.CustomField): Observable<boolean>;
  getFieldConnectionFromTemplate(docusignTemplateId: number, templateId: string): Observable<Model.IFieldQuestionConnect>;
  savingCustomFieldQuestionConnection(docusignTemplateId: number, fieldMapping: { fieldName: string, question: Model.ICustomFieldQuestionPerAgreement }[]): Observable<boolean>;
  //saveSurveyTemplateInfoToAgreement(param: { surveyTemplateId: number, agreementId: number }[]): Observable<boolean>;

  getAccountInAgreementArray(fundOnboardingId: number): Observable<Model.IAccountInAgreement>;
  saveAgreementInfoToAccount(onboardingFundId: number, param: { accountId: number, agreementTemplateId: number }[]): Observable<boolean>;
  getWizardStepConfigByFundId(fundId: number): Observable<Model.IWizardStepData>;
  updateQuestionSurveyTemplate(param: Model.IQuestionPerSurveyTemplate): Observable<boolean>;
  updateDisplayOrderColumnAndStepInfoForQuestionSurveyTemplate(param: { id: number, displayOrder: number, columnId: number, stepId: number }[]): Observable<boolean>;
  saveWizardStepModel(param: Model.IInvestorWizardStepModel): Observable<boolean>;
  calculateMaxSignerCount(onboardingfundId: number): Observable<boolean>;

  getDisplayTypeStringOfQuesiton(renderType: string): string;
  getRenderSettingString(renderSetting: Model.SpecialTextRenderType): string;
  getRenderSettingArray(): { value: string, displayValue: string }[];
  getQuestionRenderTypeArray(isRiskQuesiton: boolean, isSelectableQuestion?: boolean): { value: string, displayValue: string }[];
  getQuestionRenderTypeArrayNewDesign(isRiskQuesiton: boolean, isSelectableQuestion?: boolean): { value: string, displayValue: string }[];
  getFreeSelectableQuestionRenderTypeArray(isRiskQuestion?: boolean): { value: string, displayValue: string }[];
  removeStandardDisplayType(input: { value: string, displayValue: string }[]): { value: string, displayValue: string }[];
  recoverStandarddisplayType(input: { value: string, displayValue: string }[]): { value: string, displayValue: string }[];
  isAnswerOptionVisibleForRenderType(questionRenderType: string): boolean;
  isStandardQuestionRenderType(renderType: string): boolean;
  updateQuesitonLib(param: Model.IQuestionTemplate): Observable<Model.IQuestionTemplate>;
  deleteQuestionLib(param: Model.IQuestionTemplate): Observable<boolean>;
  deleteSurveyTemplate(id: number): Observable<boolean>;
  updateSurveyTemplate(param: Model.ISurveyTemplateEdit): Observable<boolean>;
  removeAccount(id: number);
  removeContact(id: number);

  getViewModelForCreatingFunShell(): Observable<Model.IViewModelForCreatingFundShell>;
  getIssuerArray(keyWord: string): Observable<Model.IIdString[]>;
  //downloadAccountTemplate(): Observable<Blob>;
  openDocuSignPopupCenter(url: string, title: string, width: number, height: number);
  closeDocusignPopupWindow(docusignWindow: any, retryCount: number, maxRetryCount: number);
  getDocusignSignUrlForCurrentUser(onboardingAccountId: number);
  refreshSignUrl(originalSignUrl: string);
  requestSignUrlForPilotTest(signerName: string, investorTypeId: number);
  ReorderPartialTemplateOrder(param: { id: number, order: number }[]);
  AddPartialTemplate(param: IDocusignTemplate): Observable<IDocusignTemplate>;

  addTimeZoneOffset(originalTime: Date): Date;
  subtractTimeZoneOffset(originalTime: Date): Date;

  changeParentRole(roleId: number, parentRoleId: number);
  removeRole(roleId: number);
  removeSignRoleFromTemplate(roleName: string, docusignTemplateId: number): Observable<boolean>;

  getMasterTemplateList(agreementTemplateId: number);
  changeMasterTemplate(agreementTemplateId: number, masterTemplateId: number);
  deleteQuestionSurveyTemplate(questionId: number, agreementId: number);
  changeSignatureRoleQuestion(param: { agreementTemplateId: number, roleArray: { id: number, signatureRoleName: string }[], questionContent: string });

  searchExistingUser(keyword: string, dealId: number): Observable<IUserCard[]>;
  insertOrUpdateSignatureRole(role: ISignatureRole, docuTemplateId: number): Observable<ISignatureRole>;
  refreshToken();
  insertOrUpdateFrontQuestion(question: IFrontFaceQuestion): Observable<number>;


  addNewAccount(input: any): Observable<{ dealRelationshipId: number, onboardingAccountId: number }>;
  addNewContact(input: any): Observable<any>;
  updateFundSetupType(input: any): Observable<any>;
  updateFundTimeframe(input: any): Observable<any>;
  deleteOnboarding(id: number): Observable<any>;

  downloadFile(url: string, fileName: string): void;
}
